/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indicator priority ratings
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type IndicatorPriorityRatingEnum = 'Low' | 'Medium' | 'High' | 'Very High';

export const IndicatorPriorityRatingEnum = {
    Low: 'Low' as IndicatorPriorityRatingEnum,
    Medium: 'Medium' as IndicatorPriorityRatingEnum,
    High: 'High' as IndicatorPriorityRatingEnum,
    VeryHigh: 'Very High' as IndicatorPriorityRatingEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');

